<template>
  <div class="sidenav-content-container">
    <div class="sidenav-content-frame">
      <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-001 hotfix — v-if="!isMobile" 제거 -->
      <!--   Phase 3 시점에는 모바일 사이드바 사용 불가라 메뉴 영역 자체를 숨겼으나, -->
      <!--   본 SPEC Phase 5에서 모바일 토글 복구 후 메뉴는 모바일에서도 표시되어야 함. -->
      <!--   isMobile data + handleResize는 향후 모바일 전용 분기 확장 대비 보존(dead 아님). -->
      <div
          v-for="(category, categoryIndex) in menu"
          :key="`category-${categoryIndex}-${category.name}`"
          class="sidenav-category-container"
      >
        <div
            class="sidenav-category-title"
            v-if="category.name"
        >
          <span>{{ category.name }}</span>
        </div>
        <div
            v-for="(item, itemIndex) in (category.menu || [])"
            :key="`menu-${categoryIndex}-${itemIndex}-${item.menuId || item.link}`"
            class="sidenav-category-items"
        >
          <sidenav-item
              :url="item.link"
              :class="getRoute() === item.link ? 'active' : ''"
              :navText="item.menuName"
              :outerPath="item.isNewWindow === 'Y' ? item.link : null"
              @mouseover="hoverKey = `${categoryIndex}-${itemIndex}`"
              @mouseleave="hoverKey = null"
          >
            <template v-slot:icon>
              <!-- hover 상태는 로컬 hoverKey로 추적 — store에서 온 item 객체를 직접 변경하지 않음(vuex strict mode 위반 방지) -->
              <img
                  :src="getRoute() === item.link || hoverKey === `${categoryIndex}-${itemIndex}` ? item.iconActiveUrl : item.iconDefaultUrl"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SidenavItem from './SidenavItem.vue';
import {RouterEnum} from "@/enums/router.enums";

export default {
  name: 'SidenavList',
  props: {
    menu: {
      type: Array,
    }
  },
  components: {
    SidenavItem,
  },
  data() {
    return {
      // hover 중인 메뉴 키(`${categoryIndex}-${itemIndex}`) — store item 직접 변경 대신 로컬 추적
      hoverKey: null,
    };
  },
  // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-MOBILE-SIDENAV-POLISH-001 Phase F — isMobile/handleResize/mounted/beforeUnmount dead 제거 (R-3)
  //   hotfix #2로 v-if="!isMobile" 제거된 후 isMobile 사용처 0건. resize listener도 dead.
  //   Vue 컴포넌트 mount/unmount 시 불필요한 함수 호출 + listener 등록/해제 비용 0.
  //   향후 모바일 분기 필요 시 store 또는 별도 composable로 추가 (이 컴포넌트는 menu 표시 책임만).
  methods: {
    getRoute() {
      return this.$route.path;
    },
  },
};
</script>
